import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VDivider,{staticClass:"opacity-6"}),_c('div',{staticClass:"d-flex flex-row-reverse"},[_c(VTooltip,{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn,_vm._g(_vm._b({staticClass:"navbar-toggler-icon pa-7",attrs:{"id":"open-navbar-toggler-icon","tile":"","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleMiniDrawer($event)}}},'v-btn',attrs,false),on),[_c(VIcon,{domProps:{"textContent":_vm._s(
              !_vm.mini ? 'mdi-chevron-double-left' : 'mdi-chevron-double-right'
            )}})],1)]}}])},[_c('span',{domProps:{"textContent":_vm._s(!_vm.mini ? 'Show Less' : 'Show More')}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }